import { designCenterConst } from "../constants/designCenterConst";
import { designCenterService } from "../../services/API/designCenterService";

import { frontConstants } from "../constants/frontConstants";
import { frontService } from "../../services/API/frontService";

import auth from "../../services/auth";
import { history } from "../store/configureStore";
export const designCenterActions = {
  getAllAssets,
  addAsset,
  deleteAsset,
  getAssetDetail,
  updateAsset,
  getAllAssetsColor,
  updateAssetColor,
  getAssetColorDetail,
  addAssetColor,
  getThemeData,
  getCityDetail, 
  getCustomPage,
  CustomPageCreate,
  CustomPageUpdate,
  CustomPageDelete,
  CustomDataByURL,
};

function addAsset(asset) {
  return dispatch => {
    dispatch(request(asset));
    designCenterService.addAsset(asset).then(
      asset => {
        dispatch(success(asset));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(asset) {
    return { type: designCenterConst.ADD_ASSET, asset };
  }
  function success(asset) {
    return { type: designCenterConst.ADD_ASSET_SUCCESS, asset };
  }
  function failure(error) {
    return { type: designCenterConst.ADD_ASSET_FAILURE, error };
  }
}

function addAssetColor(assetColor) {
  return dispatch => {
    dispatch(request(assetColor));
    designCenterService.addAssetColor(assetColor).then(
      assetColor => {
        dispatch(success(assetColor));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(assetColor) {
    return { type: designCenterConst.ADD_ASSET_COLOR, assetColor };
  }
  function success(assetColor) {
    return { type: designCenterConst.ADD_ASSET_COLOR_SUCCESS, assetColor };
  }
  function failure(error) {
    return { type: designCenterConst.ADD_ASSET_COLOR_FAILURE, error };
  }
}

function getAllAssets(formdata) {
  return dispatch => {
    designCenterService.getAllAssets(formdata).then(
      allassets => {
        dispatch(success(allassets));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allassets) {
    return { type: designCenterConst.VIEW_ALL_ASSETS_REQUEST, allassets };
  }
  function success(allassets) {
    return { type: designCenterConst.VIEW_ALL_ASSETS_SUCCESS, allassets };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ALL_ASSETS_FAILURE, error };
  }
}

function getAllAssetsColor(formdata) {
  return dispatch => {
    designCenterService.getAllAssetsColor(formdata).then(
      allAssetsColor => {
        dispatch(success(allAssetsColor));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(allAssetsColor) {
    return {
      type: designCenterConst.VIEW_ALL_ASSETS_COLOR_REQUEST,
      allAssetsColor
    };
  }
  function success(allAssetsColor) {
    return {
      type: designCenterConst.VIEW_ALL_ASSETS_COLOR_SUCCESS,
      allAssetsColor
    };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ALL_ASSETS_COLOR_FAILURE, error };
  }
}

function deleteAsset(assetID) {
  return dispatch => {
    designCenterService.deleteAsset(assetID, status).then(
      asset => {
        dispatch(success(asset));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(asset) {
    return { type: designCenterConst.DELETE_ASSET, asset };
  }
  function success(asset) {
    return { type: designCenterConst.DELETE_ASSET_SUCCESS, asset };
  }
  function failure(error) {
    return { type: designCenterConst.DELETE_ASSET_FAILURE, error };
  }
}

function getAssetDetail(id) {
  return dispatch => {
    designCenterService.getAssetDetail(id).then(
      asset => {
        dispatch(success(asset));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(asset) {
    return { type: designCenterConst.VIEW_ASSET_DETAIL, asset };
  }
  function success(asset) {
    return { type: designCenterConst.VIEW_ASSET_DETAIL_SUCCESS, asset };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ASSET_DETAIL_FAILURE, error };
  }
}

function getAssetColorDetail(id) {
  return dispatch => {
    designCenterService.getAssetColorDetail(id).then(
      assetColor => {
        dispatch(success(assetColor));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(assetColor) {
    return { type: designCenterConst.VIEW_ASSET_COLOR_DETAIL, assetColor };
  }
  function success(assetColor) {
    return {
      type: designCenterConst.VIEW_ASSET_COLOR_DETAIL_SUCCESS,
      assetColor
    };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ASSET_COLOR_DETAIL_FAILURE, error };
  }
}

function updateAsset(asset) {
  return dispatch => {
    dispatch(request(asset));
    designCenterService.updateAsset(asset).then(
      asset => {
        dispatch(success(asset));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(asset) {
    return { type: designCenterConst.UPDATE_ASSET, asset };
  }
  function success(asset) {
    return { type: designCenterConst.UPDATE_ASSET_SUCCESS, asset };
  }
  function failure(error) {
    return { type: designCenterConst.UPDATE_ASSET_FAILURE, error };
  }
}

function updateAssetColor(assetColor) {
  return dispatch => {
    dispatch(request(assetColor));
    designCenterService.updateAssetColor(assetColor).then(
      assetColor => {
        dispatch(success(assetColor));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(assetColor) {
    return { type: designCenterConst.UPDATE_ASSET_COLOR, assetColor };
  }
  function success(assetColor) {
    return { type: designCenterConst.UPDATE_ASSET_COLOR_SUCCESS, assetColor };
  }
  function failure(error) {
    return { type: designCenterConst.UPDATE_ASSET_COLOR_FAILURE, error };
  }
}

function getThemeData(data) {
  return dispatch => {
    designCenterService.getThemeData(data).then(
      themeData => {
        dispatch(success(themeData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(themeData) {
    return { type: designCenterConst.VIEW_THEME_DATA, themeData };
  }
  function success(themeData) {
    return { type: designCenterConst.VIEW_THEME_DATA_SUCCESS, themeData };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_THEME_DATA_FAILURE, error };
  }
}

function CustomDataByURL(formdata) {
  return dispatch => {
    designCenterService.CustomDataByURL(formdata).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_REQUEST, data };
  }
  function success(data) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_FAILURE, error };
  }
}

function getCityDetail(asset) {
  return dispatch => {
        frontService.getSiteCity()
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
  };
  function request(data) { return { type: frontConstants.GET_CITY_REQUEST, data } }
  function success(data) { return { type: frontConstants.GET_CITY_SUCCESS, data } }
  function failure(error) { return { type: frontConstants.GET_CITY_FAILURE, error } }
}

export const  getLogo = (data) => {
  return dispatch => {
    designCenterService.getThemeData(data).then(
      themeData => {
        dispatch(success(themeData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(themeData) {
    return { type: designCenterConst.VIEW_THEME_DATA, themeData };
  }
  function success(themeData) {
    return { type: designCenterConst.VIEW_THEME_DATA_SUCCESS, themeData };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_THEME_DATA_FAILURE, error };
  }
}

export const  getCustomPage = (formdata) => {
  return dispatch => {
    designCenterService.getCustomPage(formdata).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_REQUEST, data };
  }
  function success(data) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_SUCCESS, data };
  }
  function failure(error) {
    return { type: designCenterConst.VIEW_ALL_CUSTOMPAGE_FAILURE, error };
  }
}


export const CustomPageCreate = formData => {  
  return dispatch => { 
    designCenterService.CustomPageCreate(formData).then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) { 
    return { type: designCenterConst.CUSTOMPAGE_ADD_REQUEST, data }; 
  }
  function success(data) { 
    return { type: designCenterConst.CUSTOMPAGE_ADD_SUCCESS, data }; 
  }
  function failure(error) { 
    return { type: designCenterConst.CUSTOMPAGE_ADD_FAILURE, error }; 
  }
}


export const CustomPageUpdate = formData => { 
  return dispatch => { 
    designCenterService.CustomPageUpdate(formData).then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) { 
    return { type: designCenterConst.CUSTOMPAGE_UPDATE_REQUEST, data }; 
  }
  function success(data) { 
    return { type: designCenterConst.CUSTOMPAGE_UPDATE_SUCCESS, data }; 
  }
  function failure(error) { 
    return { type: designCenterConst.CUSTOMPAGE_UPDATE_FAILURE, error }; 
  }
}


export const CustomPageDelete = formData => {  
  return dispatch => { 
    designCenterService.CustomPageDelete(formData).then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) { 
    return { type: designCenterConst.CUSTOMPAGE_DELETE_REQUEST, data }; 
  }
  function success(data) { 
    return { type: designCenterConst.CUSTOMPAGE_DELETE_SUCCESS, data }; 
  }
  function failure(error) { 
    return { type: designCenterConst.CUSTOMPAGE_DELETE_FAILURE, error }; 
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/designCenterActions.js